<!--
 This component takes a list of entries, show the first two medium, and the next three small
 -->
<template>
  <section v-if="entries.length > 0">
    <!--  The double medium cards  -->
    <div class="grid grid-cols-12 gap-y-6 gap-4 sm:gap-5 lg:gap-8 mb-6 sm:mb-8 sm:pb-8 sm:border-b border-app-primary-grey--black-squeeze">
      <template v-for="(entry, index) of entries.slice(0, 2)" :key="index">
        <div class="col-span-6">
          <slot name="medium" :entry="entry" :index="index" />
        </div>
      </template>
    </div>
    <!-- The first 4 or 3 small cards (until lg screens it's 4 and from lg it's 3, for better layout on tablet) -->
    <div v-if="entries.length > 3" class="grid grid-cols-12 gap-y-6 gap-4 sm:gap-5 lg:gap-8 pb-6 sm:pb-8 border-b border-app-primary-grey--black-squeeze mb-4 sm:mb-8 lg:mb-10">
      <template v-for="(entry, index) of entries.slice(2, 6)" :key="index">
        <div class="col-span-6 lg:col-span-4" :class="{ 'lg:hidden': index === 3 }">
          <slot name="small" :entry="entry" :index="index" />
        </div>
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  entries: { type: Array as PropType<any[]>, required: true },
  label: { type: String, required: false, default: null },
})
</script>
